module.exports = __webpack_public_path__ + "img/girl.38f1f897.svg";